// src/pages/error404/Error404.jsx
import { Link } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import "./error404.css";

const Error404 = () => {
  const { user } = useContext(AuthContext);
  // Si el usuario está logueado, redirige a "mi-cuenta", si no, a la opción de iniciar sesión
  const loginLink = user ? "/mi-cuenta" : "/choice";
  const loginText = user ? "Mi Cuenta" : "Iniciar Sesión";

  return (
    <div className="error404-container">
      <div className="error404-card">
        <h1 className="error404-title">404</h1>
        <p className="error404-message">
          Lo sentimos, la página que buscas no se encontró.
        </p>
        <div className="error404-buttons">
          <Link to="/" className="btn error-btn">
            Ir al Inicio
          </Link>
          <Link to={loginLink} className="btn error-btn">
            {loginText}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Error404;